import { render } from "./WishesSection.vue?vue&type=template&id=51308a55&scoped=true"
import script from "./WishesSection.vue?vue&type=script&lang=js"
export * from "./WishesSection.vue?vue&type=script&lang=js"

import "./WishesSection.vue?vue&type=style&index=0&id=51308a55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51308a55"]])

export default __exports__